import i18next from "i18next";
import { makeAutoObservable } from "mobx";
import { NotificationsStore } from "stores/NotificationsStore";
import { DiscountData } from "types/purchaseMembership";
import { getErrorMessage } from "utilities/ErrorHelper";
import { TestOneTimePaymentService } from "./TestOneTimePaymentService";

export class TestOneTimePaymentStore {
  constructor(private readonly service: TestOneTimePaymentService, private readonly ns: NotificationsStore) {
    makeAutoObservable(this);
  }

  isTokenHandling: boolean = false;
  tokenId: string = '';
  tokenHandlingError: string = '';
  ThreeDSecureToken: string = '';
  ThreeDSecureError: string = '';
  subscriptionPurchased: boolean = false;

  discountData: DiscountData = {
    couponCode: '',
    discount: '',
    currencySymbol: '',
  };
  subscriptionEmail: string = '';

  purchaseSubscriptionWithAddon = async (email: string, planCode: string, currency: string, couponCode: string) => {
    try {
      this.tokenHandlingError = '';
      this.isTokenHandling = true;

      console.log(`Purchasing subscription with addon for email: ${email}, planCode: ${planCode}, currency: ${currency}, couponCode: ${couponCode}`);

      const response = await this.service.purchaseSubscriptionWithAddon(email, planCode, currency, couponCode);

      if (response.status === 'tokenReturned') {
        this.ThreeDSecureToken = response.token;
      } else if (response.status === 'success') {
        this.subscriptionPurchased = response.isSubscriptionPurchased;
        this.isTokenHandling = false; // Loading state should stop only if token is not returned
      } else {
        this.subscriptionPurchased = response.isSubscriptionPurchased;
        this.tokenHandlingError = response.errorMessage.detail;
        this.isTokenHandling = false; // Loading state should stop only if token is not returned
      }
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
  };

  tokenHandler = async (email: string, planCode: string, currency: string, couponCode: string) => {
    try {
      this.tokenHandlingError = '';
      this.isTokenHandling = true;
      const response = await this.service.tokenHandler(this.tokenId, email, planCode, currency, couponCode);

      if (response.status === 'tokenReturned') {
        this.ThreeDSecureToken = response.token;
      } else if (response.status === 'success') {
        this.subscriptionPurchased = response.isSubscriptionPurchased;
        this.isTokenHandling = false; // Loading state should stop only if token is not returned
      } else {
        this.subscriptionPurchased = response.isSubscriptionPurchased;
        this.tokenHandlingError = response.errorMessage.detail;
        this.isTokenHandling = false; // Loading state should stop only if token is not returned
      }
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
  };

  sendThreeDSecureRequest = async (
    tokenId: string,
    email: string,
    planCode: string,
    currency: string,
    couponCode: string,
    threeDSecureTokenId: string
  ) => {
    try {
      this.isTokenHandling = true;

      const response = await this.service.sendThreeDSecureRequest(
        tokenId,
        email,
        planCode,
        currency,
        couponCode,
        threeDSecureTokenId
      );

      if (response.data && response.status !== 200) {
        this.ThreeDSecureError = response.data.detail;
      } else if (response.data && response.data.data.isError) {
        this.ThreeDSecureError = i18next.t('PurchaseSubscriptionError', { ns: 'purchaseMembership' });
      } else {
        this.subscriptionPurchased = response.data.data;
      }
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
    this.isTokenHandling = false;
  };
}
